import { isJsonString, isValidIBANNumber } from './verifiers';
import { EAdminRefoundTypes } from '../domain/group.interface';

export const required = (value: any) =>
  value || typeof value === 'number' ? undefined : { id: 'error.required' };
const maxLength = (max: number) => (value: string) =>
  value && value.length > max
    ? { id: 'error.max_length', value: max }
    : undefined;

export const maxLength20 = maxLength(20);

export const minLength = (min: number) => (value: string) =>
  value && value.length < min
    ? { id: 'error.min_length', value: min }
    : undefined;

export const isNumber = (value: number | string) =>
  value && isNaN(Number(value)) ? { id: 'error.is_number' } : undefined;
const minValue = (min: number) => (value: number) =>
  value && value < min ? { id: 'error.min_value', value: min } : undefined;

export const minValue1900 = minValue(1900);

export const minvalue1 = minValue(1);

export const maxValue = (max: number) => (value: number) =>
  value && value > max ? { id: 'error.max_value', value: max } : undefined;

export const isEmail = (value: string) =>
  value && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value)
    ? { id: 'error.email' }
    : undefined;

export const alphaNumeric = (value: string) =>
  value && /[^a-zA-Z0-9 ]/i.test(value)
    ? { id: 'error.alphanumeric' }
    : undefined;

export const passwordsMatch = (value: string, allValues: any) =>
  value !== allValues.password ? { id: 'error.passwords_match' } : undefined;

export const isValidPhoneNumber = (value: string) => {
  if (!value) {
    return undefined;
  }
  const check = /^[6|7|8|9][0-9]{8}$/i.test(value);
  return check ? undefined : { id: 'error.phone_number' };
};

export const tooYoung = (value: string) =>
  value && value === 'no' ? { id: 'error.too_young' } : undefined;

export const notUnique = (
  value: any,
  allValues: any,
  fields: any,
  fieldArrayName: string,
) => {
  const x = fieldArrayName.split('.')[0];
  const fieldName = x.split('[')[0];
  const fieldIdx = parseInt(x.split('[')[1], 10);

  if (!allValues[fieldName][fieldIdx]) {
    return undefined;
  }

  return allValues[fieldName].findIndex((i: any) => i.value === value) ===
    fieldIdx
    ? undefined
    : { id: 'error.not_unique' };
};

export const isProta = (value: any, allValues: any) => {
  return allValues.prota
    ? allValues.prota.addExistingUser
      ? isJsonString(allValues.prota.addExistingUser)
        ? undefined
        : { id: 'error.prota' }
      : !!allValues.prota.addCustomUser
      ? undefined
      : { id: 'error.prota' }
    : { id: 'error.prota' };
};

export const isUsers = (value: any, allValues: any) => {
  const addU = allValues.groupAddUsers
    ? allValues.groupAddUsers.length > 1
      ? true
      : false
    : false;
  const invU = allValues.groupInviteUsers
    ? allValues.groupInviteUsers.length > 1
      ? true
      : false
    : false;
  return addU || invU ? undefined : { id: 'error.users' };
};

export const isFee = (
  value: any,
  allValues: any,
  fields: any,
  fieldArrayName: string,
) => {
  return allValues.groupFee
    ? allValues.groupFee.length > 1
      ? undefined
      : { id: 'error.fee' }
    : { id: 'error.fee' };
};

export const isPresent = (value: any, allValues: any) => {
  const checkValueNewWishes =
    allValues.newWishes &&
    allValues.newWishes.filter((el: any) => !!el.value).length;
  const checkValueUserWishes =
    allValues.userWishes &&
    allValues.userWishes.filter((el: any) => !!el.id).length;
  return !!checkValueNewWishes || !!checkValueUserWishes
    ? undefined
    : { id: 'error.present' };
};

export const isValueInArray = (
  value: any,
  allValues: any,
  fields: any,
  fieldArrayName: string,
) => {
  const x = fieldArrayName.split('.')[0];
  const fieldName = x.split('[')[0];
  return allValues[fieldName] && allValues[fieldName].length > 1
    ? undefined
    : { id: 'error.required' };
};

export const isValidDate = (value: any) => {
  if (!value) {
    return undefined;
  }
  if (value.indexOf('/') === -1) {
    return { id: 'error.notValidDate' };
  }
  let date = value.split('/');
  date = date.map((el: string) => +el);
  const [dd, mm, yyyy] = date;
  if (dd > 31 || mm > 12 || yyyy > 2019 || yyyy < 1900) {
    return { id: 'error.notValidDate' };
  } else {
    return undefined;
  }
};

export const isValidIban = (value: string) => {
  if (!value) {
    return undefined;
  }
  const check = isValidIBANNumber(value);
  return check === 1 ? undefined : { id: 'error.notValidIban' };
};

export const isRefound = (value: any, allValues: any) => {
  const check =
    !!allValues[EAdminRefoundTypes.iban] ||
    !!allValues[EAdminRefoundTypes.bizum]
      ? true
      : false;
  return check ? undefined : { id: 'error.refound' };
};

export const isValidDocument = (value: string) => {
  const nifRegex = /^[0-9]{8}[TRWAGMYFPDXBNJZSQVHLCKET]$/i;
  const nieRegex = /^[XYZ][0-9]{7}[TRWAGMYFPDXBNJZSQVHLCKET]$/i;
  const str = value.toString().toUpperCase();

  return !nifRegex.test(str) && !nieRegex.test(str)
    ? { id: 'error.notValidDocument' }
    : undefined;
};
